/* =========================================================
   JUGO custom cart controller (twmp x JUGO theme rebuild)
   - quantity change / remove / cross-sell add / sub switch
   - Shopify Cart AJAX API with Section Rendering (one section)
   - live "save $X more" recompute + header count update
   Dawn's cart.js is not loaded in drawer mode, so this owns
   all cart-page interactivity.
   ========================================================= */
(function () {
  'use strict';

  var ROOT_SEL = 'cart-items.twmp-cart';

  // Resolve the cart the user is acting on: the open drawer's cart, else the
  // PAGE's cart (never the hidden drawer's — matters on /cart where both exist).
  function root() {
    var open = document.querySelector('.twmp-drawer.is-open cart-items');
    if (open) return open;
    var all = document.querySelectorAll('cart-items');
    for (var i = 0; i < all.length; i++) { if (!all[i].closest('.twmp-drawer')) return all[i]; }
    return all[0] || null;
  }
  function data() {
    try {
      var r = root();
      var node = (r && r.querySelector('#twmp-cart-data')) || document.getElementById('twmp-cart-data');
      return JSON.parse(node.textContent);
    } catch (e) { return {}; }
  }

  function money(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function tier(n) {
    var t = { 1: 0, 2: 0.10, 3: 0.10, 4: 0.125, 5: 0.125, 6: 0.15 };
    var k = Math.min(Math.max(n, 1), 6);
    return t[k] != null ? t[k] : 0.15;
  }

  /* ---- cross-sell incremental savings (model-based, mirrors BYOB) ---- */
  function refreshCrossSell() {
    var d = data();
    var jarCount = d.jarCount || 0;
    var jarSub = d.jarSubtotal || 0;
    document.querySelectorAll('.twmp-xcard').forEach(function (card) {
      var p = parseInt(card.getAttribute('data-price') || '0', 10);
      var curSave = jarSub * tier(jarCount);
      var newSave = (jarSub + p) * tier(jarCount + 1);
      var delta = Math.round(newSave - curSave);
      var el = card.querySelector('[data-xsave]');
      if (!el) return;
      el.textContent = delta > 0 ? 'Save ' + money(delta) + ' more' : 'Stack to save up to 15%';
    });
  }

  /* ---- free-gift lines ($0, added by the Dealeasy GWP app) ----
     The cart hides them: the gift tracker says which ones are coming, and the
     summary prices them Free. Everything that counts the cart therefore has to
     count what the customer actually chose, or the header bubble and the line
     list disagree. Mirrors the Liquid test in twmp-cart-contents. */
  var GIFT_HANDLES = ['free-freshener', 'free-tote', 'free-hat'];
  function isGiftLine(item) {
    if (!item) return false;
    if (GIFT_HANDLES.indexOf(item.handle) > -1) return true;
    /* original_line_price must ALSO be 0: a real product knocked to $0 by a
       100%-off code is a paid line the customer chose, and hiding it would
       leave them no way to remove it. A true gift is $0 before discounts too. */
    return item.final_line_price === 0 && item.original_line_price === 0 &&
           item.handle !== 'mix-match-bundle';
  }
  // Lines the customer chose (what the rendered list shows).
  function payableLines(cart) {
    if (!cart || !cart.items) return null;
    return cart.items.filter(function (i) { return !isGiftLine(i); }).length;
  }
  // Units the customer chose (what the header bubble should read).
  function payableUnits(cart) {
    if (!cart || !cart.items) return null;
    var n = 0;
    cart.items.forEach(function (i) { if (!isGiftLine(i)) n += i.quantity; });
    return n;
  }

  function updateHeaderCount(count) {
    if (count == null) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-empty', count === 0 ? 'true' : 'false');
    });
  }

  function busy(on) {
    var r = root();
    if (r) r.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  // Soft re-render fallback: when the cart-items section isn't part of the
  // current page (e.g. the drawer open on a non-cart page), re-fetch /cart and
  // swap <cart-items> in place — no jarring full-page reload.
  function softReload() {
    var pv = '';
    try { var p = new URLSearchParams(window.location.search).get('preview_theme_id'); if (p) pv = '?preview_theme_id=' + encodeURIComponent(p); } catch (e) {}
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart' + pv)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-items');
        var current = root();
        if (fresh && current) current.replaceWith(fresh);
        refreshCrossSell();
        return fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { updateHeaderCount(payableUnits(c)); });
      })
      .catch(function () { window.location.reload(); });
  }

  /* ---- swap the cart section HTML returned by the AJAX section render ---- */
  function applySections(json) {
    var d = data();
    var id = d.sectionId;
    var html = json && json.sections && id ? json.sections[id] : null;
    if (!html) { softReload(); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(ROOT_SEL) || doc.querySelector('[data-section-id]');
    var current = root();
    if (fresh && current) {
      current.replaceWith(fresh);
    } else {
      softReload();
      return;
    }
    if (typeof json.item_count === 'number') {
      var pu = payableUnits(json);
      updateHeaderCount(pu == null ? json.item_count : pu);
    }
    refreshCrossSell();
  }

  /* ---- Gift-with-purchase (Dealeasy) reconciliation ----
     The GWP app adds/removes $0 gift lines ASYNCHRONOUSLY a few hundred ms AFTER
     our own cart change, so the section we just rendered can be stale — a gift
     still showing after dropping below its threshold, or missing right after
     crossing it. Poll the real cart briefly and, whenever its line count no
     longer matches what the drawer shows, re-render the drawer section. */
  function renderedLineCount() {
    var r = root();
    return r ? r.querySelectorAll('.twmp-line').length : null;
  }
  function rerenderFromCart() {
    var d = data();
    if (!d.sectionId) { softReload(); return; }
    var pv = '';
    try { var p = new URLSearchParams(window.location.search).get('preview_theme_id'); if (p) pv = '&preview_theme_id=' + encodeURIComponent(p); } catch (e) {}
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + '?sections=' + encodeURIComponent(d.sectionId) + pv)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        return fetch(base + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          applySections({ sections: sections, item_count: cart.item_count, items: cart.items });
        });
      })
      .catch(function () { softReload(); });
  }
  var reconcileTimers = [];
  function reconcileGifts() {
    reconcileTimers.forEach(clearTimeout);
    reconcileTimers = [];
    [450, 1100, 1900].forEach(function (ms) {
      reconcileTimers.push(setTimeout(function () {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var shown = renderedLineCount();
          var expected = payableLines(cart);
          if (shown !== null && expected !== null && expected !== shown) rerenderFromCart();
          updateHeaderCount(payableUnits(cart));
        }).catch(function () {});
      }, ms));
    });
  }

  function postJSON(url, body) {
    var d = data();
    body.sections = [d.sectionId];
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function changeLine(line, quantity, sellingPlan) {
    busy(true);
    var body = { line: line, quantity: quantity };
    if (sellingPlan !== undefined) body.selling_plan = sellingPlan;
    return postJSON('/cart/change.js', body)
      .then(function (json) { applySections(json); reconcileGifts(); })
      .catch(function () { softReload(); })
      .finally(function () { busy(false); });
  }

  function addVariant(variantId) {
    busy(true);
    window.__twmpInternalAdd = 1; // tell the drawer controller this add is handled here
    return postJSON('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] })
      .then(function (json) {
        applySections(json);
        reconcileGifts();
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateHeaderCount(payableUnits(cart)); });
      })
      .catch(function () { softReload(); })
      .finally(function () { busy(false); window.__twmpInternalAdd = 0; });
  }

  /* ---- event delegation (survives section swaps) ---- */
  document.addEventListener('click', function (e) {
    var r = root();
    if (!r) return;

    var qtyBtn = e.target.closest('.twmp-qty__btn');
    if (qtyBtn && r.contains(qtyBtn)) {
      e.preventDefault();
      var wrap = qtyBtn.closest('.twmp-qty');
      var input = wrap.querySelector('[data-qty-input]');
      var line = parseInt(wrap.getAttribute('data-line'), 10);
      var delta = parseInt(qtyBtn.getAttribute('data-qty-delta'), 10);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      changeLine(line, next);
      return;
    }

    var rm = e.target.closest('[data-remove]');
    if (rm && r.contains(rm)) {
      e.preventDefault();
      changeLine(parseInt(rm.getAttribute('data-line'), 10), 0);
      return;
    }

    var add = e.target.closest('[data-add]');
    if (add && r.contains(add)) {
      e.preventDefault();
      add.setAttribute('aria-busy', 'true');
      addVariant(add.getAttribute('data-add'));
      return;
    }

    var sw = e.target.closest('[data-sub-switch]');
    if (sw && r.contains(sw)) {
      e.preventDefault();
      var ln = parseInt(sw.getAttribute('data-line'), 10);
      var plan = sw.getAttribute('data-plan');
      var li = sw.closest('.twmp-line');
      var qInput = li ? li.querySelector('[data-qty-input]') : null;
      var qty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;
      changeLine(ln, qty, plan);
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var r = root();
    if (!r) return;
    var input = e.target.closest('[data-qty-input]');
    if (input && r.contains(input)) {
      var line = parseInt(input.getAttribute('data-line'), 10);
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      changeLine(line, qty);
    }
  });

  // Exposed so the drawer can recompute cross-sell savings after injecting content.
  window.twmpCartRefresh = refreshCrossSell;
  // Exposed so the drawer's own header counter uses ONE definition of "a count".
  window.twmpCartGifts = { isGiftLine: isGiftLine, payableLines: payableLines, payableUnits: payableUnits };

  if (document.readyState !== 'loading') refreshCrossSell();
  else document.addEventListener('DOMContentLoaded', refreshCrossSell);
})();
